import store from '../store';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      meta: { public: true },
      redirect: {
        path: '/login'
      }
    },
    {
      path: '*',
      meta: { public: true },
      redirect: {
        path: '/login'
      }
    },
    {
      path: '/login',
      meta: { public: true },
      name: 'Login',
      component: () => import(
        '@/pages/Login.vue'
      ),
    },
    {
      path: '/clientes',
      name: 'Clientes',
      component: () => import(
        '@/pages/Clientes.vue'
      ),
    },
    {
      path: '/clientes/:id',
      name: 'Cliente',
      component: () => import(
        '@/pages/Cliente.vue'
      ),
    },
    {
      path: '/pedidos',
      name: 'Pedidos',
      component: () => import(
        '@/pages/Pedidos.vue'
      ),
    },
    {
      path: '/pedidos/novo',
      name: 'Novo',
      component: () => import(
        '@/pages/Pedido.vue'
      ),
    },
    {
      path: '/pedidos/:id',
      name: 'NaoEnviado',
      component: () => import(
        '@/pages/Pedido.vue'
      ),
    },
    {
      path: '/pedidos/:id/print',
      name: 'Imprimir',
      component: () => import(
        '@/components/Impressao.vue'
      ),
    },
    {
      path: '/relatorios',
      name: 'Relatórios',
      component: () => import(
        '@/pages/Relatorios.vue'
      ),
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js